import React from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from './ui/alert-dialog';

export function DawidConfirm({
  open,
  content = "Are you sure you want to restart the survey? All progress that has not been saved will be lost.",
  confirmText = "Reset",
  cancelText = "I changed my mind, don't reset",
  onConfirm,
  onCancel,
}) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent id="confirmReset">
        <AlertDialogHeader>
          <AlertDialogTitle>Confirm action</AlertDialogTitle>
          <AlertDialogDescription>{content}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid="cancel-action">
            {cancelText}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="confirm-action">
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
